import styled from 'styled-components'

import { Card, LoadingSpinner } from 'mf-ui-components'

import { marginBreakpoints, hideBlockAt } from '../../../../utils/commonAttrs'
import { fromBreakpoint } from '../../../../utils/style/breakpoint'
import { BaseBlockProps } from '../../../../types/BaseBlockProps'
import { spacing } from '../../../../utils/ui/spacing'

export const StyledCard = styled(Card)`
  padding: ${spacing('md')};

  ${fromBreakpoint('md')} {
    padding: ${spacing('lg')};
  }
`

export const DoughnutContainer = styled.div`
  position: relative;
  height: 360px;

  ${fromBreakpoint('md')} {
    height: 480px;
  }
`

export const AllocationCategoryContainer = styled.div`
  padding: ${spacing('2xs')};
  display: flex;
  flex-direction: row;
  border: 1px solid #e5e5e5;
  border-radius: 4;
  justify-content: space-between;
  gap: ${spacing('2xs')};
  max-width: 90%;
  margin: 0 auto;

  ${fromBreakpoint('md')} {
    margin: 0;
  }
`

export const AllocationCategoryButtonsSeparator = styled.div`
  width: 1px;
  height: 100%;
  background-color: #e5e5e5;
  margin: auto 0;
`

export const AllocationCategoryButton = styled.div<{ isActive: boolean }>`
  text-align: center;
  padding: ${spacing('xs')} ${spacing('md')};
  display: inline-block;
  cursor: ${({ isActive }) => (isActive ? 'default' : 'pointer')};
  color: ${({ isActive, theme }) =>
    isActive
      ? theme.tokens.accent.onToken.secondary.regular
      : theme.tokens.accent.token.secondary.regular};
  border-radius: 4px;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.tokens.accent.token.secondary.regular : 'transparent'};
  font-weight: ${({ theme }) => theme.typography.font.weight.semibold};
  transition: background-color 0.075s ease-in-out;
  width: 29vw;

  :hover {
    ${({ isActive, theme }) =>
      !isActive &&
      'background-color: ' + theme.tokens.interface.neutral.lightest};
  }

  ${fromBreakpoint('md')} {
    width: 120px;
  }
`

export const TabWrapper = styled.div`
  overflow: hidden;
  width: 100%;
`

export const Spinner = styled(LoadingSpinner)`
  display: block;
  margin: 0 auto;
`

export const LoadingPane = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.tokens.interface.neutral.light};
  display: flex;
  margin: auto;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 400px;
  border-radius: 4px;
`

export const AssetsBreakdownContainer = styled.div<BaseBlockProps>`
  ${({ hiddenAt }) => hideBlockAt({ hiddenAt: hiddenAt })};
  ${({ marginBottom }) => marginBreakpoints({ marginBottom })};
`
